import React, { useEffect } from 'react';
import { Paper, Typography } from '@mui/material'
import { borderRadius, Box } from '@mui/system'

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';

import step1 from "./../../assets/CamiSteps/1.png"
import step2 from "./../../assets/CamiSteps/2.png"
import step3 from "./../../assets/CamiSteps/3.png"
import step4 from "./../../assets/CamiSteps/4.png"
import SentimentSatisfiedAltRoundedIcon from '@mui/icons-material/SentimentSatisfiedAltRounded';

import { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { getQueryParamValue, getVideoAvailabilityStatus } from '../../Business/MediaBusiness';
import { getPublicQrScanLocation, hasQrLinkParams } from '../../Business/CamiCodeScanBusiness';
import { CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import { getCamiCodesListWithPaginationByFilter } from '../../Repository/Api';
import {
    findLatestPlayableVideoForUser,
    rowBelongsToUser,
} from '../../Repository/CamiCodeVideosApi';
import Link from '@mui/material/Link';
import { useAuthUser } from '../../Context/AuthUserContext';
import { PLAYBOOK_LOGO } from '../../theme/brandAssets';


function CamiSteps() {
    const theme = useTheme();
    const smallDevices = useMediaQuery(theme.breakpoints.down('md'));
    const [option, setOption] = useState("")
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const { authReady, profile, profileLoading, isLoggedIn, refreshProfile } = useAuthUser();
    const [latestInsightsLoading, setLatestInsightsLoading] = useState(false);
    const [ownsCamiCode, setOwnsCamiCode] = useState(false);
    const [ownsCamiCodeChecked, setOwnsCamiCodeChecked] = useState(false);
    const [hasLatestInsightsVideo, setHasLatestInsightsVideo] = useState(false);
    const freeCamiExist = (profile?.freeCamiCodes || 0) > 0;
    const camiforeverExist = (profile?.foreverCamiCodes || 0) > 0;

    const resolveUserFilterId = () => {
        const userId = Number(profile?.id);
        if (Number.isFinite(userId) && userId > 0) {
            return userId;
        }
        const coachId = Number(profile?.coachId);
        return Number.isFinite(coachId) && coachId > 0 ? coachId : 0;
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClose1 = () => {
        setAnchorEl(null);
        localStorage.setItem('RT', 'P1');
        localStorage.removeItem('PAID');
        setOption("1 QR Code 20 mins - $6.99")
    };
   
    const handleClose3 = () => {
        setAnchorEl(null);
        localStorage.setItem('RT', 'P2');
        setOption("1 QR Code 20 mins - $6.99")
    };
  
    useEffect(() => {
        if (hasQrLinkParams(window.location)) {
            navigate(getPublicQrScanLocation(window.location), { replace: true });
        }
    }, [navigate]);

    useEffect(() => {
        let cancelled = false;

        async function checkOwnedCamiCodes() {
            if (!isLoggedIn) {
                if (!cancelled) {
                    setOwnsCamiCode(false);
                    setHasLatestInsightsVideo(false);
                    setOwnsCamiCodeChecked(true);
                }
                return;
            }

            let activeProfile = profile;
            console.log(activeProfile)
            if (activeProfile && activeProfile.id == null) {
                try {
                    activeProfile = (await refreshProfile()) || activeProfile;
                } catch {
                    /* keep existing profile */
                }
            }

            const filterId = (() => {
                const userId = Number(activeProfile?.id);
                if (Number.isFinite(userId) && userId > 0) return userId;
                const coachId = Number(activeProfile?.coachId);
                return Number.isFinite(coachId) && coachId > 0 ? coachId : 0;
            })();

            if (!filterId || !activeProfile) {
                if (!cancelled) {
                    setOwnsCamiCode(false);
                    setHasLatestInsightsVideo(false);
                    setOwnsCamiCodeChecked(true);
                }
                return;
            }

            try {
                console.log(filterId)
                const data = await getCamiCodesListWithPaginationByFilter(1, 50, filterId, "");
                console.log(data)
                const rows = Array.isArray(data?.list) ? data.list : [];
                const belongs = rows.some((row) => rowBelongsToUser(row, activeProfile));
                const latestOwnedPlayable = findLatestPlayableVideoForUser(rows, activeProfile);
                console.log(belongs)
                if (!cancelled) {
                    setOwnsCamiCode(belongs);
                    setHasLatestInsightsVideo(Boolean(latestOwnedPlayable?.videoId));
                    setOwnsCamiCodeChecked(true);
                }
            } catch {
                if (!cancelled) {
                    setOwnsCamiCode(false);
                    setHasLatestInsightsVideo(false);
                    setOwnsCamiCodeChecked(true);
                }
            }
        }

        checkOwnedCamiCodes();
        return () => {
            cancelled = true;
        };
    }, [isLoggedIn, profile?.id, profile?.coachId, profile?.email, refreshProfile]);

   

    const stepColor = theme.palette.secondary.main;
    const mainColor = theme.palette.primary.main;
    const stepsCardStyle = {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        marginTop: 2,
        marginBottom: 2
    }
    const stepsCardStyleSM = {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        marginTop: 1,
        marginBottom: 1
    }
    const stepsContainer = {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-evenly",
        marginLeft: 15,
        marginRight: 15,
    }

    const dialogButtons = {
        display: 'block',
        margin: '10px auto',
        width: '100%',
        borderRadius: 20,
        width: "100%"
    }


    const stepsContainerSM = {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-evenly",
        marginLeft: 2,
        marginRight: 2,
    }

    const title = { display: "flex", flexDirection: "column", alignItems: "center", }
    const cardsContentsTwo = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "200px",
        backgroundColor: mainColor,
        borderRadius: "20px",
        height: "120px"
    }
    const cardsContentsTwoSM = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "150px",
        backgroundColor: mainColor,
        borderRadius: "20px",
        height: "100px"
    }
    const step1Style = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    }
    const stepTextBlue = {
        color: "white",
        backgroundColor: stepColor,
        width: "70px",
        textAlign: "center",
        alignItems: "flex-start",
        borderRadius: "20px",
        position: "relative",
        bottom: -8,
        left: 15
    }
    const stepTextBlueSM = {
        color: "white",
        backgroundColor: stepColor,
        width: "55px",
        textAlign: "center",
        alignItems: "flex-start",
        borderRadius: "20px",
        position: "relative",
        bottom: -8,
        left: 15,
        fontSize: "13px"
    }
    const itsEasyStyle = {
        color: mainColor,
        padding: 4,
        fontWeight: "bold",
        fontSize: 20
    }
    const sponsorTitleStyle = {
        ...itsEasyStyle,
        textAlign: "center",
        fontSize: { xs: "2rem", sm: "2.2rem", md: "2.12rem" },
        fontWeight: 800,
        letterSpacing: "-0.02em",
        color: "#FFFFFF",
        p: 0,
        lineHeight: 1.25,
        width: "100%",
        maxWidth: { xs: "100%", md: "430px" },
        mx: "auto",
    }
    const coachCaptureTitleStyle = {
        ...sponsorTitleStyle,
        fontSize: { xs: "1.9rem", sm: "2.09rem", md: "2.014rem" },
    }
    const sponsorHeroLogoStyle = {
        display: "block",
        width: "auto",
        height: { xs: 120, sm: 140, md: 160 },
        maxWidth: "min(88vw, 420px)",
        objectFit: "contain",
        mx: "auto",
    }
    const sponsorTopCard = {
        backgroundColor: "transparent",
        borderRadius: 0,
        border: "none",
        boxShadow: "none",
        px: { xs: 1, sm: 1.5 },
        py: { xs: 1, sm: 1.5 },
        width: "min(92vw, 520px)",
        textAlign: "center",
        mx: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }
    const sponsorCenteredStack = {
        width: "100%",
        maxWidth: "540px",
        mx: "auto",
        px: { xs: 1.5, sm: 2 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
    }
    const sponsorFullSection = {
        ...sponsorCenteredStack,
        minHeight: "calc(100vh - 360px)",
        marginTop: { xs: 2, sm: 3 },
        marginBottom: { xs: 2, sm: 3 },
        gap: { xs: 2.5, sm: 3 },
    }
    const sponsorBottomInfoCard = {
        backgroundColor: "#FFFFFF",
        borderRadius: "16px",
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: "0 2px 8px rgba(14, 28, 44, 0.05)",
        px: { xs: 2.2, sm: 2.6 },
        py: { xs: 1.8, sm: 2.2 },
        width: "min(92vw, 520px)",
        textAlign: "center",
        mx: "auto",
    }
    const sponsorInfoText = {
        color: theme.palette.text.secondary,
        fontSize: "1rem",
        lineHeight: 1.5,
    }
    const coachInsightsBottomCard = {
        ...sponsorBottomInfoCard,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        alignSelf: "center",
        width: "min(92vw, 520px)",
        mx: "auto",
        boxSizing: "border-box",
    }
    const coachInsightsText = {
        color: mainColor,
        fontSize: { xs: "0.8rem", sm: "0.8125rem" },
        fontWeight: 350,
        lineHeight: 1.45,
        textAlign: "center",
        letterSpacing: "0.01em",
        width: "100%",
        maxWidth: "26rem",
        margin: "0 auto",
        boxSizing: "border-box",
    }
    const sponsorPageSection = {
        flex: 1,
        width: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    }
    const mainContent = {
        paddingLeft: 2, paddingRight: 0, color: "#fff",
        width: "100px",
    }


    const mainContent1 = {
        paddingLeft: 2, paddingRight: 0, color: "#fff",
        width: "115px",
    }


    const mainContent1SM = {
        paddingLeft: 2, paddingRight: 0, color: "#fff",
        width: "90px", fontSize: "12px"
    }
    const stepImageSM = {
        width: "62px",
        height: "62px",
        objectFit: "contain",
        paddingRight: "6px",
    }
    const stepImageLG = {
        width: "86px",
        height: "86px",
        objectFit: "contain",
        paddingRight: "8px",
    }
    const fullStepCardSM = {
        width: "160px",
        height: "96px",
        objectFit: "contain",
    }
    const fullStepCardLG = {
        width: "220px",
        height: "130px",
        objectFit: "contain",
    }
    const stepsImages = [step1, step2, step3, step4];


    const recipientStyle = {
        color: "white",
        display: "flex",
        fontWeight: "600",
        alignItems: "center",
        justifyContent: "center",
        width: "350px",
        backgroundColor: mainColor,
        borderRadius: 8,
        padding: 1,
    }

    const recipientStyle1 = {
        color: "white",
        display: "flex",
        fontWeight: "bold",
        alignItems: "center",
        justifyContent: "center",
        width: "400px",
        padding: 1,
        backgroundColor: mainColor, color: "white",
        "&:hover": { backgroundColor: theme.palette.secondary.main },
        textTransform: "capitalize",
    }

    const recepientContainer = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        marginTop: 5,
        marginBottom:3
    }

    const recepientContainer2 = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign:"center",
        width: "100%",
        marginTop: 5,
        marginBottom: 5,
    }
    const getStarted = {
        display: "flex",
        width: "100%",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 5,
        marginBottom: 10
    }
    const sponsorActionsContainer = {
        ...sponsorCenteredStack,
        minHeight: 0,
        marginTop: { xs: "20px", sm: "26px" },
        marginBottom: { xs: 3, sm: 3.5 },
        gap: { xs: 1.6, sm: 1.9 },
    }
    const getStartedText = {
        backgroundColor: theme.palette.secondary.main,
        color: "#ffffff",
        padding: 2,
        width: "264px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        fontSize: "1.1rem",
        fontWeight: 700,
        letterSpacing: "0.02em",
        borderRadius: "999px",
        boxShadow: "0 4px 14px rgba(153, 6, 14, 0.28)",
        transition: "background-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease",
        whiteSpace: "nowrap",
        wordBreak: "keep-all",
        marginLeft: "auto",
        marginRight: "auto",
        alignSelf: "center",

        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
            boxShadow: "0 6px 18px rgba(153, 6, 14, 0.35)",
            transform: "translateY(-1px)",
        },
    }
    const disabledGetStartedText = {
        ...getStartedText,
        "&.Mui-disabled": {
            backgroundColor: theme.palette.secondary.main,
            backgroundImage: "linear-gradient(rgba(128, 128, 128, 0.35), rgba(128, 128, 128, 0.35))",
            color: "rgba(255, 255, 255, 0.75)",
            opacity: 1,
            boxShadow: "none",
            transform: "none",
        },
    }
    const sponsorPrimaryButton = {
        ...getStartedText,
        backgroundColor: theme.palette.secondary.main,
        color: "#ffffff",
        width: "min(88vw, 500px)",
        minHeight: "56px",
        borderRadius: "14px",
        fontSize: "1.2rem",
        fontWeight: 700,
        textTransform: "none",
        mx: "auto",
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
            boxShadow: "0 6px 18px rgba(153, 6, 14, 0.35)",
            transform: "translateY(-1px)",
        },
    }
    const postCommentsPrimaryButton = {
        ...sponsorPrimaryButton,
        padding: theme.spacing(2 * 0.85, 2),
    }
    const sponsorSecondaryButton = {
        ...getStartedText,
        backgroundColor: "#FFFFFF",
        color: theme.palette.primary.main,
        width: "min(88vw, 500px)",
        minHeight: "56px",
        borderRadius: "14px",
        fontSize: "1.2rem",
        fontWeight: 600,
        textTransform: "none",
        mx: "auto",
        boxShadow: "none",
        border: `1.5px solid ${theme.palette.divider}`,
        "&:hover": {
            backgroundColor: "#FFFFFF",
            borderColor: theme.palette.secondary.main,
            color: theme.palette.secondary.main,
            boxShadow: "0 2px 8px rgba(14, 28, 44, 0.06)",
            transform: "translateY(-1px)",
        },
    }
    const numberStyle = {
        fontSize: 25
    }

    const menuStyle = {
        width: "250px",
        alignSelf: "center",
        color: "#000",
        "&:hover": {
            backgroundColor: theme.palette.secondary.main,
        },
    }
    const menuContainer = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    }
   
    const handleUploadNavigate = () =>{
        if (freeCamiExist) {
            navigate("/free-qr");
            return;
        }
        navigate("/upload-video")
    }
    const handleScanQrNavigate = () => {
        navigate("/scan-qr");
    }
    const handleWatchLatestInsights = async () => {
        if (latestInsightsLoading || !ownsCamiCode) {
            return;
        }
        const filterId = resolveUserFilterId();
        if (!filterId) {
            return;
        }
        setLatestInsightsLoading(true);
        try {
            const data = await getCamiCodesListWithPaginationByFilter(1, 50, filterId, "");
            const rows = Array.isArray(data?.list) ? data.list : [];
            const latestPlayableVideo = findLatestPlayableVideoForUser(rows, profile);
            if (!latestPlayableVideo) {
                return;
            }
            navigate(
                `/previous-videos?c=${encodeURIComponent(latestPlayableVideo.camiCode)}&p=${encodeURIComponent(
                    String(latestPlayableVideo.uniqueId).replace(/ /g, "")
                )}&v=${encodeURIComponent(latestPlayableVideo.videoId)}&redir=${encodeURIComponent("/")}`
            );
        } catch (error) {
            /* stay on home */
        } finally {
            setLatestInsightsLoading(false);
        }
    }

    
    const CustomButton = styled(Button)(({ theme }) => ({
    color: "#FFFFFF",
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 999,
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "0 4px 14px rgba(153, 6, 14, 0.28)",
    transition: "background-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease",
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      boxShadow: "0 6px 18px rgba(153, 6, 14, 0.35)",
    },
  }));


    useEffect(() => {
        if (localStorage.getItem('RT')) {
            if (localStorage.getItem('RT') == 'P1') {
                setOption("1 QR Code 20 mins - $6.99")
            }
            if (localStorage.getItem('RT') == 'P2') {
                setOption("1 QR Code 20 mins - $6.99")
            }
        }
    }, [])

    if (!authReady || (isLoggedIn && profileLoading && !profile)) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "40vh" }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{
            ...sponsorPageSection,
            backgroundColor: "#F8F6F2",
        }}>
            <Box sx={sponsorFullSection}>
                <Box sx={sponsorTopCard}>
                    <Box
                        component="img"
                        src={PLAYBOOK_LOGO}
                        alt="Playbook"
                        sx={sponsorHeroLogoStyle}
                    />
                </Box>
                {isLoggedIn && ownsCamiCodeChecked && ownsCamiCode && hasLatestInsightsVideo ? (
                    <Button onClick={handleWatchLatestInsights} disabled={latestInsightsLoading} sx={sponsorPrimaryButton}>
                        Watch Latest Insights
                    </Button>
                ) : null}
                <Button onClick={handleScanQrNavigate} sx={sponsorSecondaryButton}>
                    Scan QR Code
                </Button>
                <Box sx={sponsorBottomInfoCard}>
                    <Typography sx={sponsorInfoText}>
                        {isLoggedIn && ownsCamiCode && hasLatestInsightsVideo
                            ? "Scan a QR code or watch latest insights to view exclusive content"
                            : "Scan a QR code to view exclusive content"}
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default CamiSteps
